module.exports = __webpack_public_path__ + "img/mon-agrial.cce5fd62.svg";